import { render, staticRenderFns } from "./ListConfig.vue?vue&type=template&id=79c98f04&scoped=true"
import script from "./ListConfig.vue?vue&type=script&lang=js"
export * from "./ListConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c98f04",
  null
  
)

export default component.exports